import React from "react";
import { Card, Typography } from 'antd';
import { Link } from 'react-router-dom'
import 'dayjs/locale/uk';
const { Text, Title, Paragraph } = Typography;

const AboutSubComponent = () => {
    return (
        <Card className="compact-section-card compact-copy-card" bordered={false}>
            <Title level={5} style={{marginTop: 0}}>Обслуговування, ремонт і поліпшення прибудинкової території.</Title>
            <Paragraph><Link to='/about'>Керуюча компанія "Гетьман-1"</Link></Paragraph>
            <Title level={5}>Інформація про послугу</Title>
            <Paragraph><Text strong>Вартість: </Text><Text>один акаунт 50 гривень. Один аккаунт отримує доступ до додатка PalGate на 1 пристрої і може мати брелок і пульт від хвірток і воріт.</Text></Paragraph>
            <Paragraph><Text strong>Публічний договір можна переглянути тут: </Text> <Link to='/contract'>договір</Link></Paragraph>
        </Card>
    )
}

export default AboutSubComponent
